<template>
  <expandable-material-card
    :title="$t('components.portal.lifeEventsCCWIPP')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="event"
  >
    <member-life-events-groups-table
      :items="groups"
      @update="$emit('update-groups', $event)"
      :systemColors="systemColors"
      :selectedLanguages="selectedLanguages"
    />
    <member-life-events-categories-table
      :items="categories"
      @update="$emit('update-categories', $event)"
      :systemColors="systemColors"
      :selectedLanguages="selectedLanguages"
    />
    <v-card-title>{{ $t("components.portal.lifeEventsCCWIPP") }}</v-card-title>
    <v-card-text>
      <pbas-data-table
        ref="table"
        :showSelect="false"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="mle"
        identifier="mle"
        @error="error = $event"
      ></pbas-data-table>
    </v-card-text>

    <v-dialog scrollable v-model="deleteDialog" persistent max-width="400">
      <material-card
        v-if="editedItem"
        :title="$t('components.portal.faq.delete', [editItem.Name])"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="editDialog" persistent max-width="1200px">
      <material-card
        v-if="editedItem !== null && editedItem !== undefined"
        :title="formTitle"
        :icon="formIcon"
        :color="formColor"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fill-height fluid>
              <v-row wrap>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <v-select
                    v-model="editedItem.Group"
                    :label="$t(`components.portal.faq.group`)"
                    :items="groups"
                    :rules="[$rules.required]"
                    class="required"
                    :item-text="groupText"
                    item-value="GroupEN"
                    return-object
                  ></v-select>
                </div>
                <!-- <div
                  class="col-12 col-xs-12 col-sm-6 col-md-4"
                  v-for="lang in languages"
                  :key="`Group${lang.language}`"
                >
                  <no-autocomplete-textfield
                    v-model="editedItem[`Group${lang.language.toUpperCase()}`]"
                    :label="
                      $t(`headers.faq.group_{0}`, [lang.language.toUpperCase()])
                    "
                    :rules="
                      $helpers.isRequired(lang.language, selectedLanguages)
                        ? [$rules.required]
                        : []
                    "
                    :class="
                      $helpers.isRequired(lang.language, selectedLanguages)
                        ? 'required'
                        : ''
                    "
                    :clearable="
                      !$helpers.isRequired(lang.language, selectedLanguages)
                    "
                  ></no-autocomplete-textfield>
                </div> -->
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <mdi-icons-dropdown
                    :value.sync="editedItem.GroupIcon"
                    :label="$t('headers.faq.group_icon')"
                    class="required"
                    :rules="[$rules.required]"
                  ></mdi-icons-dropdown>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-lg-4">
                  <color-selector
                    :value.sync="editedItem.IconColor"
                    :rules="[$rules.required]"
                    class="required"
                    :systemColorsOnly="true"
                    :label="$t('headers.faq.group_icon_color')"
                    :systemColors="systemColors"
                  ></color-selector>
                </div> -->
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <no-autocomplete-textfield
                    :value.sync="editedItem.TextColor"
                    :rules="[$rules.required]"
                    class="required"
                    :label="$t('headers.faq.text_color')"
                  ></no-autocomplete-textfield>
                </div>
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <no-autocomplete-textfield
                    :value.sync="editedItem.CategoryId"
                    :rules="[$rules.requiredInteger]"
                    class="required"
                    :label="$t('headers.member_life_events.category_id')"
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-xs-12 col-sm-6"
                  v-for="lang in languages"
                  :key="`Category${lang.language}`"
                >
                  <v-textarea
                    :value.sync="
                      editedItem[`Category${lang.language.toUpperCase()}`]
                    "
                    :label="
                      $t(`headers.download_centre.category_{0}`, [
                        lang.language.toUpperCase(),
                      ])
                    "
                    :rules="
                      $helpers.isRequired(lang.language, selectedLanguages)
                        ? [$rules.required]
                        : []
                    "
                    :class="
                      $helpers.isRequired(lang.language, selectedLanguages)
                        ? 'required'
                        : ''
                    "
                    :clearable="
                      !$helpers.isRequired(lang.language, selectedLanguages)
                    "
                    :rows="1"
                    auto-grow
                  ></v-textarea>
                </div>
                <div class="col-12 col-xs-12">
                  <image-picker
                    :value.sync="editedItem.CategoryImage"
                    :label="$t('headers.member_life_events.category_image')"
                  ></image-picker>
                </div>
                <div
                  class="col-12 col-xs-12"
                  v-for="lang in languages"
                  :key="`CategoryText${lang.language}`"
                >
                  <quill-input
                    :value.sync="
                      editedItem[`CategoryText${lang.language.toUpperCase()}`]
                    "
                    :rules="
                      $helpers.isRequired(lang.language, selectedLanguages)
                        ? [$rules.required]
                        : []
                    "
                    :class="
                      $helpers.isRequired(lang.language, selectedLanguages)
                        ? 'required'
                        : ''
                    "
                    :clearable="
                      !$helpers.isRequired(lang.language, selectedLanguages)
                    "
                    :label="
                      $t(`headers.member_life_events.category_text_{0}`, [
                        lang.language.toUpperCase(),
                      ])
                    "
                  />
                </div> -->
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <v-select
                    v-model="editedItem.Category"
                    :label="$t(`globals.category`)"
                    :items="categories"
                    :rules="[$rules.required]"
                    class="
                      required
                    "
                    :item-text="categoryText"
                    item-value="CategoryEN"
                    return-object
                  ></v-select>
                </div>
                <div class="col-12 col-xs-12">
                  <member-life-events-questions :items="editedItem.Questions" @update="editedItem.Questions = $event"/>
                </div>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn :disabled="!valid" color="primary" @click="save">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </expandable-material-card>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { InMemoryProvider } from "pbas-vue-components";
import getHeaders from "@/headers/MemberLifeEvents";
// import MdiIconsDropdown from "./MdiIconsDropdown.vue";
// import ColorSelector from "./ColorSelector.vue";
import MemberLifeEventsQuestions from "./MemberLifeEventsQuestions.vue";
// import ImagePicker from "./ImagePicker.vue";
import ExpandableMaterialCard from "./ExpandableMaterialCard.vue";
// import QuillInput from "./QuillInput.vue";
import MemberLifeEventsGroupsTable from "./MemberLifeEventsGroupsTable.vue";
import MemberLifeEventsCategoriesTable from "./MemberLifeEventsCategoriesTable";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    // MdiIconsDropdown,
    // ColorSelector,
    MemberLifeEventsQuestions,
    // ImagePicker,
    ExpandableMaterialCard,
    // QuillInput,
    MemberLifeEventsGroupsTable,
    MemberLifeEventsCategoriesTable,
  },
  props: ["items", "systemColors", "selectedLanguages", "groups", "categories"],
  data() {
    return {
      error: null,
      deleteDialog: false,
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: "#64ba5f",
          text: "globals.add_new",
          handler: () => {
            let item = {
              Identifier: Math.random().toString()
            };
            this.isNew = true;
            this.editItem(item);
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.isNew = false;
            this.editItem(item);
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.editedItem = item;
            this.deleteDialog = true;
          },
        },
      ],
      editDialog: false,
      valid: true,
      editedItem: null,
      isNew: false,
      provider: undefined,
      editorData: "<p>Rich-text editor content.</p>",
      editorOption: {
        modules: {
          // toolbar: {
          //   handlers: {
          //     // handlers object will be merged with default handlers object
          //     link: function(value) {
          //       console.log("link: ", value);
          //       if (value) {
          //         var href = prompt("Enter the URL");
          //         this.quill.format("link", href);
          //       } else {
          //         this.quill.format("link", false);
          //       }
          //     },
          //   },
          // },
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"], // remove formatting button
            ["link", "image", "video"],
            ["theme-btn"],
          ],
        },
      },
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("plansMembers", ["options"]),
    formTitle() {
      return this.isNew
        ? this.$t("components.portal.mle.add")
        : this.$t("components.portal.mle.edit");
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    items: {
      handler() {
        this.loadPlanData();
      },
    },
    systemColors: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  async mounted() {
    this.loadPlanData();
  },
  methods: {
    categoryText(item) {
      return item["Category"+this.language.language.toUpperCase()];
    },
    groupText(item) {
      return item["Group" + this.language.language.toUpperCase()];
    },
    updateItems(items) {
      this.$nextTick(() => {
        this.$emit("update", items);
      });
    },
    loadPlanData() {
      this.$nextTick(()=>{
        let items = [];
        if (this.items !== null && this.items !== undefined) {
          items = this.items.map((o) => {
            o.Identifier = Math.random().toString();
            return o;
          });
        }
        this.provider = new InMemoryProvider(
          items,
          getHeaders(this.languages, this.systemColors)
        );
        if (this.$refs.table) {
          this.$refs.table.getDataAsync();
          this.$forceUpdate();
        }
      });
    },
    async editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editedItem.Group = this.groups.filter(
        (o) => o.GroupEN === this.editedItem.GroupEN
      )[0];
      this.editedItem.Category = this.categories.filter(
        (o) => o.CategoryEN === this.editedItem.CategoryEN
      )[0];
      this.editDialog = true;
    },
    close() {
      this.editDialog = false;
      this.editedItem = null;
      this.$refs.form.resetValidation();
    },
    save() {
      this.editedItem.PlanIdentityId = this.planIdentityId;
      this.editedItem.GroupEN = this.editedItem.Group.GroupEN;
      this.editedItem.GroupFR = this.editedItem.Group.GroupFR;
      this.editedItem.GroupIcon = this.editedItem.Group.GroupIcon;
      this.editedItem.GroupIconColor = this.editedItem.Group.GroupIconColor;
      delete this.editedItem.Group;
      this.editedItem.CategoryId = this.editedItem.Category.CategoryId;
      this.editedItem.CategoryEN = this.editedItem.Category.CategoryEN;
      this.editedItem.CategoryFR = this.editedItem.Category.CategoryFR;
      this.editedItem.CategoryImage = this.editedItem.Category.CategoryImage;
      this.editedItem.CategoryTextEN = this.editedItem.Category.CategoryTextEN;
      this.editedItem.CategoryTextFR = this.editedItem.Category.CategoryTextFR;
      delete this.editedItem.Category;
      if (this.isNew) {
        this.add();
      } else {
        this.update();
      }
    },
    async update() {
      const item = this.provider.items.filter(
        (o) => o.Identifier === this.editedItem.Identifier
      )[0];
      const index = this.provider.items.indexOf(item);
      this.provider.items[index] = JSON.parse(JSON.stringify(this.editedItem));
      this.close();
      this.$refs.table.getDataAsync();
      this.updateItems(this.provider.items);
    },
    async add() {
      this.provider.items.push(JSON.parse(JSON.stringify(this.editedItem)));
      this.close();
      this.$refs.table.getDataAsync();
      this.updateItems(this.provider.items);
    },
    async tryDelete() {
      const item = this.provider.items.filter(
        (o) => o.Identifier === this.editedItem.Identifier
      )[0];
      const index = this.provider.items.indexOf(item);
      this.provider.items.splice(index, 1);
      this.deleteDialog = false;
      this.$refs.table.getDataAsync();
      this.updateItems(this.provider.items);
    },
  },
};
</script>
